/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResult } from '../models';
// @ts-ignore
import type { CreateGeofenceRuleDTO } from '../models';
// @ts-ignore
import type { DeleteOperationGeofenceRule200Response } from '../models';
// @ts-ignore
import type { GetOperationGeofenceRule200Response } from '../models';
// @ts-ignore
import type { ListGeofenceRulesByOperation200Response } from '../models';
// @ts-ignore
import type { UpdateGeofenceRuleDTO } from '../models';
/**
 * GeofenceApi - axios parameter creator
 */
export const GeofenceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Activate a single geofence rule from within the operation
         * @summary Activate a geofence rule
         * @param {string} operationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateOperationGeofenceRule: async (operationId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('activateOperationGeofenceRule', 'operationId', operationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('activateOperationGeofenceRule', 'id', id)
            const localVarPath = `/api/nora/geofence/operation/{operationId}/rule/{id}/activate`
                .replace('{operationId}', encodeURIComponent(String(operationId)))
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a geofence rule within an operation
         * @summary Create a geofence rule
         * @param {string} operationId 
         * @param {CreateGeofenceRuleDTO} createGeofenceRuleDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOperationGeofenceRule: async (operationId: string, createGeofenceRuleDTO: CreateGeofenceRuleDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('createOperationGeofenceRule', 'operationId', operationId)
            // verify required parameter 'createGeofenceRuleDTO' is not null or undefined
            assertParamExists('createOperationGeofenceRule', 'createGeofenceRuleDTO', createGeofenceRuleDTO)
            const localVarPath = `/api/nora/geofence/operation/{operationId}/rule`
                .replace('{operationId}', encodeURIComponent(String(operationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGeofenceRuleDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deactivate a single geofence rule from within the operation
         * @summary Deactivate a geofence rule
         * @param {string} operationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateOperationGeofenceRule: async (operationId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('deactivateOperationGeofenceRule', 'operationId', operationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deactivateOperationGeofenceRule', 'id', id)
            const localVarPath = `/api/nora/geofence/operation/{operationId}/rule/{id}/deactivate`
                .replace('{operationId}', encodeURIComponent(String(operationId)))
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a single geofence rule from within the operation
         * @summary Delete a geofence rule
         * @param {string} operationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOperationGeofenceRule: async (operationId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('deleteOperationGeofenceRule', 'operationId', operationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOperationGeofenceRule', 'id', id)
            const localVarPath = `/api/nora/geofence/operation/{operationId}/rule/{id}`
                .replace('{operationId}', encodeURIComponent(String(operationId)))
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single geofence rule from an operation using its id
         * @summary Get a geofence rule
         * @param {string} operationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperationGeofenceRule: async (operationId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('getOperationGeofenceRule', 'operationId', operationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOperationGeofenceRule', 'id', id)
            const localVarPath = `/api/nora/geofence/operation/{operationId}/rule/{id}`
                .replace('{operationId}', encodeURIComponent(String(operationId)))
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all geofence rules associated with an operation
         * @summary List geofence rules
         * @param {string} operationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGeofenceRulesByOperation: async (operationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('listGeofenceRulesByOperation', 'operationId', operationId)
            const localVarPath = `/api/nora/geofence/operation/{operationId}/rules`
                .replace('{operationId}', encodeURIComponent(String(operationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a single geofence rule within the operation
         * @summary Update a geofence rule
         * @param {string} operationId 
         * @param {string} id 
         * @param {UpdateGeofenceRuleDTO} updateGeofenceRuleDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOperationGeofenceRule: async (operationId: string, id: string, updateGeofenceRuleDTO: UpdateGeofenceRuleDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('updateOperationGeofenceRule', 'operationId', operationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOperationGeofenceRule', 'id', id)
            // verify required parameter 'updateGeofenceRuleDTO' is not null or undefined
            assertParamExists('updateOperationGeofenceRule', 'updateGeofenceRuleDTO', updateGeofenceRuleDTO)
            const localVarPath = `/api/nora/geofence/operation/{operationId}/rule/{id}`
                .replace('{operationId}', encodeURIComponent(String(operationId)))
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGeofenceRuleDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeofenceApi - functional programming interface
 */
export const GeofenceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeofenceApiAxiosParamCreator(configuration)
    return {
        /**
         * Activate a single geofence rule from within the operation
         * @summary Activate a geofence rule
         * @param {string} operationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateOperationGeofenceRule(operationId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOperationGeofenceRule200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateOperationGeofenceRule(operationId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeofenceApi.activateOperationGeofenceRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a geofence rule within an operation
         * @summary Create a geofence rule
         * @param {string} operationId 
         * @param {CreateGeofenceRuleDTO} createGeofenceRuleDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOperationGeofenceRule(operationId: string, createGeofenceRuleDTO: CreateGeofenceRuleDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOperationGeofenceRule200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOperationGeofenceRule(operationId, createGeofenceRuleDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeofenceApi.createOperationGeofenceRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deactivate a single geofence rule from within the operation
         * @summary Deactivate a geofence rule
         * @param {string} operationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateOperationGeofenceRule(operationId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOperationGeofenceRule200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deactivateOperationGeofenceRule(operationId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeofenceApi.deactivateOperationGeofenceRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a single geofence rule from within the operation
         * @summary Delete a geofence rule
         * @param {string} operationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOperationGeofenceRule(operationId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteOperationGeofenceRule200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOperationGeofenceRule(operationId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeofenceApi.deleteOperationGeofenceRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single geofence rule from an operation using its id
         * @summary Get a geofence rule
         * @param {string} operationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperationGeofenceRule(operationId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOperationGeofenceRule200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperationGeofenceRule(operationId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeofenceApi.getOperationGeofenceRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all geofence rules associated with an operation
         * @summary List geofence rules
         * @param {string} operationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listGeofenceRulesByOperation(operationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListGeofenceRulesByOperation200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listGeofenceRulesByOperation(operationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeofenceApi.listGeofenceRulesByOperation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a single geofence rule within the operation
         * @summary Update a geofence rule
         * @param {string} operationId 
         * @param {string} id 
         * @param {UpdateGeofenceRuleDTO} updateGeofenceRuleDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOperationGeofenceRule(operationId: string, id: string, updateGeofenceRuleDTO: UpdateGeofenceRuleDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOperationGeofenceRule200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOperationGeofenceRule(operationId, id, updateGeofenceRuleDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeofenceApi.updateOperationGeofenceRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GeofenceApi - factory interface
 */
export const GeofenceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeofenceApiFp(configuration)
    return {
        /**
         * Activate a single geofence rule from within the operation
         * @summary Activate a geofence rule
         * @param {GeofenceApiActivateOperationGeofenceRuleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateOperationGeofenceRule(requestParameters: GeofenceApiActivateOperationGeofenceRuleRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetOperationGeofenceRule200Response> {
            return localVarFp.activateOperationGeofenceRule(requestParameters.operationId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a geofence rule within an operation
         * @summary Create a geofence rule
         * @param {GeofenceApiCreateOperationGeofenceRuleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOperationGeofenceRule(requestParameters: GeofenceApiCreateOperationGeofenceRuleRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetOperationGeofenceRule200Response> {
            return localVarFp.createOperationGeofenceRule(requestParameters.operationId, requestParameters.createGeofenceRuleDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Deactivate a single geofence rule from within the operation
         * @summary Deactivate a geofence rule
         * @param {GeofenceApiDeactivateOperationGeofenceRuleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateOperationGeofenceRule(requestParameters: GeofenceApiDeactivateOperationGeofenceRuleRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetOperationGeofenceRule200Response> {
            return localVarFp.deactivateOperationGeofenceRule(requestParameters.operationId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a single geofence rule from within the operation
         * @summary Delete a geofence rule
         * @param {GeofenceApiDeleteOperationGeofenceRuleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOperationGeofenceRule(requestParameters: GeofenceApiDeleteOperationGeofenceRuleRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteOperationGeofenceRule200Response> {
            return localVarFp.deleteOperationGeofenceRule(requestParameters.operationId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single geofence rule from an operation using its id
         * @summary Get a geofence rule
         * @param {GeofenceApiGetOperationGeofenceRuleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperationGeofenceRule(requestParameters: GeofenceApiGetOperationGeofenceRuleRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetOperationGeofenceRule200Response> {
            return localVarFp.getOperationGeofenceRule(requestParameters.operationId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * List all geofence rules associated with an operation
         * @summary List geofence rules
         * @param {GeofenceApiListGeofenceRulesByOperationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGeofenceRulesByOperation(requestParameters: GeofenceApiListGeofenceRulesByOperationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListGeofenceRulesByOperation200Response> {
            return localVarFp.listGeofenceRulesByOperation(requestParameters.operationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a single geofence rule within the operation
         * @summary Update a geofence rule
         * @param {GeofenceApiUpdateOperationGeofenceRuleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOperationGeofenceRule(requestParameters: GeofenceApiUpdateOperationGeofenceRuleRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetOperationGeofenceRule200Response> {
            return localVarFp.updateOperationGeofenceRule(requestParameters.operationId, requestParameters.id, requestParameters.updateGeofenceRuleDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for activateOperationGeofenceRule operation in GeofenceApi.
 */
export interface GeofenceApiActivateOperationGeofenceRuleRequest {
    readonly operationId: string

    readonly id: string
}

/**
 * Request parameters for createOperationGeofenceRule operation in GeofenceApi.
 */
export interface GeofenceApiCreateOperationGeofenceRuleRequest {
    readonly operationId: string

    readonly createGeofenceRuleDTO: CreateGeofenceRuleDTO
}

/**
 * Request parameters for deactivateOperationGeofenceRule operation in GeofenceApi.
 */
export interface GeofenceApiDeactivateOperationGeofenceRuleRequest {
    readonly operationId: string

    readonly id: string
}

/**
 * Request parameters for deleteOperationGeofenceRule operation in GeofenceApi.
 */
export interface GeofenceApiDeleteOperationGeofenceRuleRequest {
    readonly operationId: string

    readonly id: string
}

/**
 * Request parameters for getOperationGeofenceRule operation in GeofenceApi.
 */
export interface GeofenceApiGetOperationGeofenceRuleRequest {
    readonly operationId: string

    readonly id: string
}

/**
 * Request parameters for listGeofenceRulesByOperation operation in GeofenceApi.
 */
export interface GeofenceApiListGeofenceRulesByOperationRequest {
    readonly operationId: string
}

/**
 * Request parameters for updateOperationGeofenceRule operation in GeofenceApi.
 */
export interface GeofenceApiUpdateOperationGeofenceRuleRequest {
    readonly operationId: string

    readonly id: string

    readonly updateGeofenceRuleDTO: UpdateGeofenceRuleDTO
}

/**
 * GeofenceApi - object-oriented interface
 */
export class GeofenceApi extends BaseAPI {
    /**
     * Activate a single geofence rule from within the operation
     * @summary Activate a geofence rule
     * @param {GeofenceApiActivateOperationGeofenceRuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public activateOperationGeofenceRule(requestParameters: GeofenceApiActivateOperationGeofenceRuleRequest, options?: RawAxiosRequestConfig) {
        return GeofenceApiFp(this.configuration).activateOperationGeofenceRule(requestParameters.operationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a geofence rule within an operation
     * @summary Create a geofence rule
     * @param {GeofenceApiCreateOperationGeofenceRuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createOperationGeofenceRule(requestParameters: GeofenceApiCreateOperationGeofenceRuleRequest, options?: RawAxiosRequestConfig) {
        return GeofenceApiFp(this.configuration).createOperationGeofenceRule(requestParameters.operationId, requestParameters.createGeofenceRuleDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deactivate a single geofence rule from within the operation
     * @summary Deactivate a geofence rule
     * @param {GeofenceApiDeactivateOperationGeofenceRuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deactivateOperationGeofenceRule(requestParameters: GeofenceApiDeactivateOperationGeofenceRuleRequest, options?: RawAxiosRequestConfig) {
        return GeofenceApiFp(this.configuration).deactivateOperationGeofenceRule(requestParameters.operationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a single geofence rule from within the operation
     * @summary Delete a geofence rule
     * @param {GeofenceApiDeleteOperationGeofenceRuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteOperationGeofenceRule(requestParameters: GeofenceApiDeleteOperationGeofenceRuleRequest, options?: RawAxiosRequestConfig) {
        return GeofenceApiFp(this.configuration).deleteOperationGeofenceRule(requestParameters.operationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single geofence rule from an operation using its id
     * @summary Get a geofence rule
     * @param {GeofenceApiGetOperationGeofenceRuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOperationGeofenceRule(requestParameters: GeofenceApiGetOperationGeofenceRuleRequest, options?: RawAxiosRequestConfig) {
        return GeofenceApiFp(this.configuration).getOperationGeofenceRule(requestParameters.operationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all geofence rules associated with an operation
     * @summary List geofence rules
     * @param {GeofenceApiListGeofenceRulesByOperationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listGeofenceRulesByOperation(requestParameters: GeofenceApiListGeofenceRulesByOperationRequest, options?: RawAxiosRequestConfig) {
        return GeofenceApiFp(this.configuration).listGeofenceRulesByOperation(requestParameters.operationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a single geofence rule within the operation
     * @summary Update a geofence rule
     * @param {GeofenceApiUpdateOperationGeofenceRuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateOperationGeofenceRule(requestParameters: GeofenceApiUpdateOperationGeofenceRuleRequest, options?: RawAxiosRequestConfig) {
        return GeofenceApiFp(this.configuration).updateOperationGeofenceRule(requestParameters.operationId, requestParameters.id, requestParameters.updateGeofenceRuleDTO, options).then((request) => request(this.axios, this.basePath));
    }
}

